import React from 'react';
import { useStyles } from './AssessmentProgressBar.styles';
import {ReactComponent as ArrowBar} from '../../../assets/icons/arrowBar.svg';
import { ExamTaskGroupSolutionsProgressData } from '../Assessment.types';
import { AssessmentSessionProcessTypeId } from '../../../services/exams/assessmentSession/assessments.types';
import { fill, fillOpacity } from '../../../utils/contrastSvgAttributes';
import { useLayoutContext } from '../../../Context/Layout.context';

interface AssessmentProgressBarProps extends ExamTaskGroupSolutionsProgressData {
  processTypeId?: AssessmentSessionProcessTypeId;
}

const AssessmentProgressBar: React.FC<AssessmentProgressBarProps> = ({
  deskLimit,
  totalLimit,
  newTaskGroupSolutions,
  openTaskGroupSolutions,
  assessedTaskGroupSolutions,
  closedTaskGroupSolutions,
  processTypeId,
}) => {
  const classes = useStyles();

  const { highContrastMode } = useLayoutContext();

  const getPercentage = (value: number, limit: number): number => {
    return limit === 0 ? 0 : Math.floor((value / limit) * 100);
  };

  const limitForNewAndOpened = [AssessmentSessionProcessTypeId.Scoring, undefined].includes(processTypeId)
    ? deskLimit
    : totalLimit;
  return (
    <div
      id="progressBar"
      className={[classes.barContainer]
        .concat(
          [AssessmentSessionProcessTypeId.Scoring, undefined].includes(processTypeId) ? [] : [classes.leftJustyfied],
        )
        .join(' ')}
      style={{border:highContrastMode ? '1px solid white' : 'none' }}
    >
      <span className={classes.span}>
        <div className={highContrastMode ? `${classes.circle} ${classes.circleContrastBackgroud}`  : `${classes.circle} ${classes.circleMagentaBackgroud}`   }>
          {limitForNewAndOpened ? <span>{getPercentage(newTaskGroupSolutions, limitForNewAndOpened)}%</span> : null}
        </div>
        <div className={classes.textArea}>
          <span className={classes.text}>Pobrane do oceny (nowe)</span>
          <br />
          <span className={classes.subText}>
            {newTaskGroupSolutions}
            {limitForNewAndOpened ? <span>/{limitForNewAndOpened}</span> : null}
          </span>
        </div>
      </span>
      <span className={classes.spanImage}>
      <ArrowBar className={classes.arrow} fill={fill} />
      </span>
      <span className={classes.span}>
        <div className={highContrastMode ? `${classes.circle} ${classes.circleContrastBackgroud}`  : `${classes.circle} ${classes.circleBlueBackgroud}`}>
          {limitForNewAndOpened ? <span>{getPercentage(openTaskGroupSolutions, limitForNewAndOpened)}%</span> : null}
        </div>
        <div className={classes.textArea}>
          <span className={classes.text}>Otwarte</span>
          <br />
          <span className={classes.subText}>
            {openTaskGroupSolutions}
            {limitForNewAndOpened ? <span>/{limitForNewAndOpened}</span> : null}
          </span>
        </div>
      </span>
      {[AssessmentSessionProcessTypeId.Scoring, undefined].includes(processTypeId) ? (
        <>
          <span className={classes.spanImage}>
            <ArrowBar className={classes.arrow} fill={fill} />
          </span>
          <span className={classes.span}>
            <div className={highContrastMode ? `${classes.circle} ${classes.circleContrastBackgroud}`  : `${classes.circle} ${classes.circleGreenBackgroud}`}>
              {totalLimit ? <span>{getPercentage(assessedTaskGroupSolutions, totalLimit)}%</span> : null}
            </div>
            <div className={classes.textArea}>
              <span className={classes.text}>Ocenione</span>
              <br />
              <span className={classes.subText}>
                {assessedTaskGroupSolutions}
                {totalLimit ? <span>/{totalLimit}</span> : null}
              </span>
            </div>
          </span>
        </>
      ) : null}
      <span className={classes.spanImage}>
      <ArrowBar className={classes.arrow} fill={fill} />
      </span>
      <span className={classes.span}>
        <div className={highContrastMode ? `${classes.circle} ${classes.circleContrastBackgroud}`  : `${classes.circle} ${classes.circlePinkBackgroud}`}>
          {totalLimit ? <span>{getPercentage(closedTaskGroupSolutions, totalLimit)}%</span> : null}
        </div>
        <div className={classes.textArea}>
          <span className={classes.text}>Zamknięte</span>
          <br />
          <span className={classes.subText}>
            {closedTaskGroupSolutions}
            {totalLimit ? <span>/{totalLimit}</span> : null}
          </span>
        </div>
      </span>
    </div>
  );
};

export default AssessmentProgressBar;
